import React, { useEffect, useState, Fragment } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
const START_SECONDS = 3 * 60 * 60 + 42 * 60 + 17; // 3h 42m 17s
const TOTAL_CUPOS = 200;
const REMAINING = 37;
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function UrgencyBlock() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const pct = REMAINING / TOTAL_CUPOS * 100;
  return <div className="rounded-2xl border border-gold/40 bg-navy-deep/80 p-4" data-id="element-48">
      <div className="mb-3 flex items-center justify-center gap-2 text-gold" data-id="element-49">
        <ClockIcon className="h-4 w-4" data-id="element-50" />
        <span className="text-xs font-bold uppercase tracking-widest" data-id="element-51">
          La oferta termina en
        </span>
      </div>
      <div className="mb-4 flex items-center justify-center gap-2" data-id="element-52">
        {[{
        v: h,
        l: 'Hs'
      }, {
        v: m,
        l: 'Min'
      }, {
        v: s,
        l: 'Seg'
      }].map(t => <Fragment key={t.l} data-id="element-53">
            <div className="flex flex-col items-center" data-id="element-54">
              <span className="min-w-[48px] rounded-lg bg-gold px-2 py-1.5 text-center font-display text-2xl font-extrabold text-navy-deep" data-id="element-55">
                {pad(t.v)}
              </span>
              <span className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-slate-300" data-id="element-56">
                {t.l}
              </span>
            </div>
          </Fragment>)}
      </div>

      <div className="mb-1.5 flex items-center justify-between text-xs font-semibold text-slate-200" data-id="element-57">
        <span className="flex items-center gap-1" data-id="element-58">
          <UsersIcon className="h-3.5 w-3.5 text-gold" data-id="element-59" /> Cupos restantes
        </span>
        <span className="text-gold" data-id="element-60">
          {REMAINING} / {TOTAL_CUPOS}
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-61">
        <div className="h-full rounded-full bg-gradient-to-r from-gold-dark to-gold transition-all" style={{
        width: `${pct}%`
      }} data-id="element-62" />
      </div>
      <p className="mt-2 text-center text-[11px] text-slate-400" data-id="element-63">
        Quedan muy pocos lugares con este precio.
      </p>
    </div>;
}